import toast from '@liquidweb-dev/undercurrent/toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
	LWApiPublicServerAuthUpdateParamsRawI,
	LWApiPublicServerAuthUpdateResultRawI,
} from '@liquidweb-dev/club-sauce/public/server/auth/index.raw';
import { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import { ASSET_CONTROL_PANEL_CREDENTIALS_USERNAME_PASSWORD } from 'modules/queries/asset/controlPanel/credentials/useUsernameAndPassword';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import { SERVER_AUTH_DETAILS_QUERY_KEY } from './useDetails';

const useServerAuthUpdate = () => {
	const snackbarError = useSnackbarError();
	const queryClient = useQueryClient();

	return useMutation<
		LWApiPublicServerAuthUpdateResultRawI,
		ApiErrorI,
		LWApiPublicServerAuthUpdateParamsRawI
	>({
		mutationFn: (params) => api.server.auth.apiRaw.update(params),
		onSuccess: (_data, params) => {
			queryClient.invalidateQueries({
				queryKey: [SERVER_AUTH_DETAILS_QUERY_KEY, { uniq_id: params.uniq_id }],
			});
			queryClient.invalidateQueries({
				queryKey: [ASSET_CONTROL_PANEL_CREDENTIALS_USERNAME_PASSWORD],
			});
		},
		onError: (error) => {
			if (error.errorClass?.includes('LW::Exception::Input')) {
				toast.danger('One or more of the values you provided are invalid');
			} else {
				snackbarError(error);
			}
		},
	});
};

export default useServerAuthUpdate;
